__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "pflm-materials";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@pflm-shared", "0.2.307", () => (Promise.all([__webpack_require__.e(507), __webpack_require__.e(598), __webpack_require__.e(445), __webpack_require__.e(689), __webpack_require__.e(541)]).then(() => (() => (__webpack_require__(507))))));
			register("@tanstack/react-query-persist-client", "5.85.3", () => (Promise.all([__webpack_require__.e(985), __webpack_require__.e(598), __webpack_require__.e(71), __webpack_require__.e(848)]).then(() => (() => (__webpack_require__(3985))))));
			register("@tanstack/react-query", "5.85.3", () => (Promise.all([__webpack_require__.e(946), __webpack_require__.e(598), __webpack_require__.e(467)]).then(() => (() => (__webpack_require__(3946))))));
			register("mobx-react-lite", "4.1.0", () => (Promise.all([__webpack_require__.e(443), __webpack_require__.e(598), __webpack_require__.e(186), __webpack_require__.e(445)]).then(() => (() => (__webpack_require__(3443))))));
			register("mobx", "6.13.7", () => (__webpack_require__.e(813).then(() => (() => (__webpack_require__(7813))))));
			register("react-dom", "19.1.1", () => (Promise.all([__webpack_require__.e(598), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(961))))));
			register("react-router-dom", "7.8.1", () => (Promise.all([__webpack_require__.e(996), __webpack_require__.e(598), __webpack_require__.e(186)]).then(() => (() => (__webpack_require__(3996))))));
			register("react", "19.1.1", () => (__webpack_require__.e(540).then(() => (() => (__webpack_require__(6540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};